import styled, { css } from "styled-components";

interface SwitchButtonProps {
  checked: boolean;
}

export const PageWrapper = styled.div`
  background-color: whitesmoke;
  padding: 25px;
  min-height: 100vh;
`

export const Container = styled.div`
  max-width: 960px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 36px;
  background: white;
  border-radius: 8px;
  border: 1px solid rgba(0,0,0,0.1);
`;

export const ProfileName = styled.h2`
  font-weight: 600;
  color: #1f2937;
`;

export const ProfileEmail = styled.p`
  font-size: 0.875rem;
  color: #6b7280;
`;

export const Details = styled.dl`
  display: grid;
  grid-template-columns: 1fr;
  gap: 0.75rem;
  font-size: 0.875rem;
  color: #4b5563;
`;

export const DetailTitle = styled.dt`
  font-weight: 600;
  color: #1f2937;
`;

export const DetailContent = styled.dd`
  color: #6b7280;
`;

export const HeaderText = styled.p`
    font-size: 0.875rem;
    color: #6b7280;
`;

export const LinkButton = styled.a`
    margin-top: 1.25rem;
    font-size: 0.875rem;
    color: #6b7280;
    text-decoration: underline;
    cursor: pointer;
`;

export const ContentContainer = styled.div`
    margin-top: 1.25rem;
`;

export const GridContainer = styled.div`
    display: grid;
    grid-template-columns: repeat(1, minmax(0, 1fr));
    gap: 1rem;

    @media (min-width: 640px) {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }

    @media (min-width: 768px) {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }

    @media (min-width: 1024px) {
        grid-template-columns: repeat(3, minmax(0, 1fr));
    }
`;

export const SwitchButton = styled.button<SwitchButtonProps>`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.5rem 0.75rem;
    border-radius: 9999px;
    border: 1px solid #d1d5db;
    background-color: white;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
    text-align: left;
    width: 100%;
    cursor: pointer;
    transition: background-color 0.2s ease-in-out;

    &:hover {
        background-color: #f9fafb;
    }

    ${(props) =>
    props.checked &&
    css`
            border-color: #4299e1;
        `}
`;

export const IconContainer = styled.span`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 1rem;
    height: 1rem;
`;

export const OptionText = styled.span`
    flex: 1;
    min-width: 0;
    margin-left: 0.5rem;
    font-size: 0.875rem;
    font-weight: 500;
    color: #1f2937;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;